module.exports = __webpack_public_path__ + "img/53.ea16a700.jpg";